import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  userService,
  vmDataService,
  vmSharedModelService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editCustomRiskControlQuestionDialog from '../dialog.editCustomRiskControlQuestionDialog';
import controller from './edit-custom-risk-control-dialog.controller';
import customRiskControlNameMessagesTpl from './custom-risk-control-name.messages.html';
import customRiskControlStrengthMessagesTpl from './custom-risk-control-strength.messages.html';
import template from './edit-custom-risk-control-dialog.html';


class dialogService {
  getOptions($event, { settings, customRiskControl }) {
    return {
      controller,
      controllerAs: 'editCustomRiskControlDialogVM',
      locals: {
        settings,
        customRiskControl
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.editCustomRiskControlDialog', [
  alerts,
  confirmDialog,
  constants,
  loaderService,
  ssDialogService,
  userService,
  vmDataService,
  vmSharedModelService,
  editCustomRiskControlQuestionDialog,
])
  .service('editCustomRiskControlDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('custom-risk-control-name.messages.html', customRiskControlNameMessagesTpl);
    $templateCache.put('custom-risk-control-strength.messages.html', customRiskControlStrengthMessagesTpl);
  })
  .name;
